import { Log } from 'oidc-client';

const DefaultTimeout = 10000;

export class IFrameNavigator {
  prepare() {
    const frame = new IFrameWindow();
    return Promise.resolve(frame);
  }

  callback(url) {
    Log.debug('IFrameNavigator.callback');

    try {
      IFrameWindow.notifyParent(url);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }
}

class IFrameWindow {
  private _promise: Promise<unknown>;
  private _resolve: ((value: unknown) => void) | undefined;
  private _reject: ((reason?: any) => void) | undefined;
  private _boundMessageEvent: ((e: any) => void) | null = null;
  private _frame: HTMLIFrameElement;
  private _timer: number | null = null;

  constructor() {
    this._promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });

    this._boundMessageEvent = this._message.bind(this);
    window.addEventListener('message', this._boundMessageEvent, false);

    this._frame = window.document.createElement('iframe');

    // When I say shotgun, you say wedding
    this._frame.style.visibility = 'hidden';
    this._frame.style.position = 'absolute';
    this._frame.width = '0';
    this._frame.height = '0';

    window.document.body.appendChild(this._frame);
  }

  navigate(params) {
    if (!params || !params.url) {
      this._error('No url provided');
    } else {
      const timeout = params.silentRequestTimeout || DefaultTimeout;
      Log.debug('IFrameWindow.navigate: Using timeout of:', timeout);
      this._timer = window.setTimeout(this._timeout.bind(this), timeout);
      this._frame.src = params.url;
    }

    return this.promise;
  }

  get promise() {
    return this._promise;
  }

  _success(data) {
    this._cleanup();

    Log.debug('IFrameWindow: Successful response from frame window');
    this._resolve && this._resolve(data);
  }
  _error(message) {
    this._cleanup();

    Log.error(message);
    this._reject && this._reject(new Error(message));
  }

  close() {
    this._cleanup();
  }

  _cleanup() {
    if (this._frame) {
      Log.debug('IFrameWindow: cleanup');

      if (this._boundMessageEvent) {
        window.removeEventListener('message', this._boundMessageEvent, false);
      }
      if (this._timer) {
        window.clearTimeout(this._timer);
      }
      window.document.body.removeChild(this._frame);

      this._timer = null;
      this._boundMessageEvent = null;
    }
  }

  _timeout() {
    Log.debug('IFrameWindow.timeout');
    this._error('Frame window timed out');
  }

  _message() {
    Log.debug('IFrameWindow.message');
    this._success({});
  }

  get _origin() {
    return `${location.protocol}//${location.host}`;
  }

  static notifyParent(url) {
    Log.debug('IFrameWindow.notifyParent');
    url = url || window.location.href;
    if (url) {
      Log.debug('IFrameWindow.notifyParent: posting url message to parent');
      window.parent.postMessage(url, `${location.protocol}//${location.host}`);
    }
  }
}
